import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileNameDisplay"];

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  displayFileName() {
    const file = this.fileInputTarget.files[0];
    if (file) {
      this.fileNameDisplayTarget.textContent = file.name;
    } else {
      this.fileNameDisplayTarget.textContent = "No file selected";
    }
  }
}
